import React, { useEffect, useState } from 'react'
import swal from 'sweetalert'
import Modal from './Modal'
import { useDispatch, useSelector } from 'react-redux'
import ModalHeader from './ModalHeader'
import { assignmentAddModal } from '../features/assignment/assignmentSlice'
import { useGetVideosQuery } from '../features/video/videoApi'
import { useAddAssignmentMutation, useGetAssignmentsQuery } from '../features/assignment/assignment.Api'

export default function AddAssignment() {
    const dispatch = useDispatch()
    const { modal } = useSelector(state => state.assignment)
    const { isSuccess: isSuccessFetchVideos, data: videos } = useGetVideosQuery()
    const { isSuccess: isSuccessFetchAssignments, data: assignments } = useGetAssignmentsQuery()

    const [addAssignment, { isSuccess: isSuccessAddAssignment }] = useAddAssignmentMutation()

    const [videosOption, setVideosOption] = useState([])

    const [title, setTitle] = useState("")
    const [video, setVideo] = useState(null)
    const [totalMark, setTotalMark] = useState(0)

    useEffect(() => {
        if (isSuccessFetchAssignments && assignments?.length > 0 && isSuccessFetchVideos && assignments?.length > 0) {
            const assignment_video_id = assignments?.map(assignment => assignment.video_id)
            const assignmentUnassignedVideo = videos.filter(video => !assignment_video_id?.includes(video.id))
            setVideosOption(assignmentUnassignedVideo)
            assignmentUnassignedVideo.length === 1 && setVideo(assignmentUnassignedVideo[0])

        }
    }, [isSuccessFetchAssignments, isSuccessFetchVideos, assignments, videos])


    useEffect(() => {
        if (isSuccessAddAssignment) {
            swal("Successful", "Assignment add successful", "success");
            resetForm()
            dispatch(assignmentAddModal())
        }
    }, [isSuccessAddAssignment, dispatch])

    function handleCreateNewAssignment(e) {
        e.preventDefault();

        if (title && totalMark && video) {
            addAssignment({ title, video_id: video?.id, video_title: video?.title, totalMark })
        }
    }

    function resetForm() {
        setTitle("")
        setTotalMark(0)
        setVideo({})
    }

    return (
        <>
            {modal && <Modal>
                <div className='px-8 mx-auto w-[90%] md:w-2/4 border-dashed border-2 border-blue-300 rounded-lg'>
                        <ModalHeader title="Add New Assignment" closeModal={() => dispatch(assignmentAddModal())} />
                    <form onSubmit={handleCreateNewAssignment} className='py-8'>
                        <div className="mb-6">
                            <label htmlFor="title" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Assignment Title</label>
                            <input type="text" id="title" onChange={e => setTitle(e.target.value)} value={title} name="title" className="border rounded-lg  block w-full p-1 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required />
                        </div>

                        <div className="mb-6">
                            <label htmlFor="video_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select Video</label>
                            <select type="text" id="video_id" onChange={e => setVideo(JSON.parse(e.target.value))} value={video} name="video_id" className="border rounded-lg  block w-full p-1 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required >
                                {videosOption?.length > 0 ? videosOption.map(video => <option key={video.id} value={JSON.stringify(video)}>{video.title}</option>) : <option>No video available</option>}
                            </select>
                        </div>

                        <div className="mb-6">
                            <label htmlFor="totalMark" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Total Mark</label>
                            <input type="number" id="totalMark" onChange={e => setTotalMark(e.target.value)} value={totalMark} name="totalMark" className="border rounded-lg  block w-full p-1 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required />
                        </div>

                        <button type="submit" className="video-add-submit-btn text-white focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2 text-center bg-blue-600 hover:bg-blue-700 focus:ring-blue-800">Add Assignment</button>
                    </form>
                </div>
            </Modal>}
        </>
    )
}
